<template>
  <div>
    <div align="left" class="mt-4">
      <h4 class="h5 mb-3 text-primary font-weight-bold">Extra Packaging</h4>
    </div>
    <br />
    <b-row>
      <b-col md="8">
        <b-card class="text-left">
          <h5 class="font-weight-bold text-primary">Create New</h5>
          <br />
          <br />
          <b-row>
            <b-col>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Code Extra Packaging"
                    label-for="input-1"
                  >
                    <input
                      id="input-1"
                      type="text"
                      class="form-control"
                      v-validate="'required|max:25'"
                      name="code"
                      data-vv-as="Code Extra Packaging"
                      v-model="code"
                      placeholder="Code"
                    />
                    <b-form-invalid-feedback id="input-code-feedback">{{ veeErrors.first('code') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Name Bahasa"
                    label-for="input-1"
                  >
                    <input
                      id="input-1"
                      type="text"
                      class="form-control"
                      v-validate="'required|max:25'"
                      name="name_id"
                      data-vv-as="Name Bahasa"
                      v-model="name_id"
                      placeholder="Name Bahasa"
                    />
                    <b-form-invalid-feedback
                      id="input-name_id-feedback"
                    >{{ veeErrors.first('name_id') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Name English"
                    label-for="input-1"
                  >
                    <input
                      id="input-1"
                      type="text"
                      class="form-control"
                      v-validate="'required|max:25'"
                      name="name_en"
                      data-vv-as="Name English"
                      v-model="name_en"
                      placeholder="Name English"
                    />
                    <b-form-invalid-feedback
                      id="input-name_en-feedback"
                    >{{ veeErrors.first('name_en') }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="Size"
                label-for="input-1"
              ></b-form-group>
              <b-row>
                <b-col>
                  <b-form-input v-model="size_length" type="number" placeholder="Length"></b-form-input>
                </b-col>
                <p class="mt-1">X</p>
                <b-col>
                  <b-form-input v-model="size_width" type="number" placeholder="Width"></b-form-input>
                </b-col>
                <p class="mt-1">X</p>
                <b-col>
                  <b-form-input v-model="size_height" type="number" placeholder="Height"></b-form-input>
                </b-col>
                <p class="mt-1">CM</p>
              </b-row>
              <br />
              <div class="form-group" v-for="(input , k) in ph_and_stock" :key="k">
                <b-row>
                  <b-col md="3">
                    <b-form-group
                      id="fieldset-1"
                      label-class="mb-0"
                      label-for="input-1"
                    >PH Stock {{k+1}}</b-form-group>
                  </b-col>
                  <b-col md="3" class="text-right">
                    <b-link
                      style="text-decoration: none;"
                      class="text-danger"
                      @click="remove(k)"
                      v-show="k || ( !k && ph_and_stock.length > 1)"
                    >Remove</b-link>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <vue-multiselect
                      v-model="input.admin_hub"
                      tag-placeholder="Add this as new tag"
                      placeholder="Search or add a Paxel House"
                      label="name"
                      track-by="code"
                      :options="ph"
                    ></vue-multiselect>
                  </b-col>
                  <b-col>
                    <input
                      id="input-1"
                      type="text"
                      class="form-control"
                      v-validate="'required|max:25'"
                      name="stock"
                      :disabled="input.admin_hub == null"
                      data-vv-as="Stock PH"
                      v-model="input.stock"
                      placeholder="Stock PH"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3" class="mt-4">
                    <b-button
                      block
                      variant="outline-primary"
                      @click="add(k)"
                      v-show="k == ph_and_stock.length-1"
                    >
                      <i class="fas fa-plus"></i> Add More
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <br />
              <b-row>
                <b-col md="6">
                  <b-form-group
                    id="input-group-1"
                    class="required"
                    label-class="control-label"
                    label="Price"
                    label-for="input-1"
                  >
                    <b-input-group>
                      <template v-slot:prepend>
                        <b-input-group-text>Rp.</b-input-group-text>
                      </template>
                      <input
                        type="text"
                        v-model="price"
                        v-validate="'required|numeric'"
                        name="price"
                        data-vv-as="Price"
                        tag-name="textarea"
                        placeholder="Enter price amount here"
                        class="form-control"
                      />
                    </b-input-group>
                    <p
                      class="text-danger"
                      style="width:100%;margin-top:.25rem;font-size: 80%;"
                    >{{ veeErrors.first('price') }}</p>
                  </b-form-group>
                </b-col>
              </b-row>
              <br />
              <b-row class="text-right">
                <b-col>
                  <b-button
                    variant="primary"
                    @click="post()"
                    :disabled="loading"
                    class="mr-5"
                  >Create</b-button>
                  <router-link :to="{name: 'ExtraPackaging'}">
                    <b-button variant="outline-secondary">Cancel</b-button>
                  </router-link>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      loading: false,
      selected: 'first',
      checked: false,
      modalShow: false,
      file: '',
      widthImage: null,
      heightImage: null,
      url: '',
      title_id: '',
      title_en: '',
      price: '',
      period_start: '',
      period_end: '',
      is_always_active: false,
      is_highlight: false,
      counthighlight: null,
      ph: [],
      ph_and_stock: [
        {
          admin_hub: null,
          stock: null,
        },
      ],
      status: [
        { text: 'Active', value: 'first' },
        { text: 'Inactive', value: 'second' },
      ],
      button: [
        { text: 'No', value: 'first' },
        { text: 'Yes', value: 'second' },
      ],
      options2: [
        { text: 'Yes', value: 'first' },
        { text: 'No', value: 'second' },
      ],
      disabledDates: {
        to: new Date(Date.now() - 8672000),
      },
    };
  },
  beforeCreate() {
    this.$store.dispatch('ArticleModule/getAdminhub');
  },
  created() {
    this.$store.watch(
      state => state.ArticleModule.Adminhub,
      (newValue, oldValue) => {
        this.ph = newValue;
      },
    );
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    resetStardate() {
      this.period_start = '';
    },
    resetEnddate() {
      this.period_end = '';
    },
    add(index) {
      this.ph_and_stock.push({
        admin_hub: null,
        stock: null,
      });
    },
    remove(index) {
      this.ph_and_stock.splice(index, 1);
    },
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const formData = new FormData();

          formData.append('code', this.code);
          formData.append('name_id', this.name_id);
          formData.append('name_en', this.name_en);
          formData.append('size_length', this.size_length);
          formData.append('size_width', this.size_width);
          formData.append('size_height', this.size_height);
          formData.append('price', this.price);
          if (this.ph_and_stock != null) {
            $.each(this.ph_and_stock, (index, value) => {
              formData.append('ph_and_stock[sequence]', index);
              formData.append(
                `ph_and_stock[admin_hub_id][${index}]`,
                value.admin_hub.id,
              );
              formData.append(
                `ph_and_stock[admin_hub_code][${index}]`,
                value.admin_hub.code,
              );
              formData.append(
                `ph_and_stock[admin_hub_name][${index}]`,
                value.admin_hub.name,
              );
              formData.append(
                `ph_and_stock[stock][${index}]`,
                value.stock,
              );
            });
          } else {
            formData.append('ph_and_stock[sequence]', this.ph_and_stock.length);
            formData.append(
              'ph_and_stock[admin_hub_id]',
              this.ph_and_stock.admin_hub,
            );
            formData.append(
              'ph_and_stock[admin_hub_code]',
              this.ph_and_stock.admin_hub,
            );
            formData.append(
              'ph_and_stock[admin_hub_name]',
              this.ph_and_stock.admin_hub,
            );
            formData.append('ph_and_stock[stock]', this.ph_and_stock.stock);
          }

          this.loading = true;
          this.$store
            .dispatch('ExtraPackagingModule/postExtraPackaging', formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: 'ExtraPackaging' });
              this.$swal({
                type: 'success',
                title: 'Your work has been saved',
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response.data;
              this.$swal({
                type: 'error',
                title: 'Oops...',
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(error);
            });
        } else {
          this.$swal('ERROR!', 'Your file cant be submit.', 'warning');
        }
      });
    },
  },
};
</script>

<style>
</style>
